$(document).ready(function () {
    $(document).on('change', '.js_tariff_change_type', TariffChangeType);

    function TariffChangeType() {
        let sendData = {
            bus_type_id: $('#id_tariff_bus_type_select').val(),
            type: $('#id_tariff_type_select').val(),
            agreement_id: $("[name='agreement_id']").val()
        };

        $.get('/admin/tariffs/get_min_value', sendData, (response) => {
            $("#min").val(response);
            $("#max").val(parseInt(response) + 1);
        });
    }
});
